/**
 * Scroll page to position of given id.
 * Offsetted by nav height.
 */
export const scrollTo = (id) => {
  const element = document.querySelector(id)
  const top = element.getBoundingClientRect().top + window.pageYOffset - 150

  window.scrollTo({
    top,
    behavior: 'smooth',
  })
}

export default {
  scrollTo,
}
